<template>
    <div v-if="item.proj_open_flg != '2'">
        <div class="card-header text-right text-muted">
            <span @click="openShare">
                <i class="fas fa-share-alt icon-size"></i>
                <small> 共有 </small>
            </span>
        </div>
        <proj-share ref="share"></proj-share>
    </div>
</template>

<script>
    import ProjShare from 'pages/commons/projShare/ProjShare'

    export default {
        props: {
            item: Object
        },
        components: {
            ProjShare
        },
        methods: {
            openShare () {
                // 案件一覧画面に合わせID追加する
                let proj = Object.assign({}, this.item)
                proj.id = proj.proj_id
                this.$refs.share.openThis(proj)
            }
        }
    }
</script>

<style></style>
